import { ListItem, ListItemAvatar, ListItemText, Skeleton } from '@mui/material';
import React from 'react';

export const FileListItemSkeleton: React.FC = () => {
  return (
    <ListItem
      divider
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        mb: 1,
        py: 0.25,
      }}
      secondaryAction={<Skeleton variant="circular" width={24} height={24} animation="wave" />}
    >
      <ListItemAvatar sx={{ minWidth: 'auto', mr: 2 }}>
        <Skeleton variant="rounded" width={36} height={24} animation="wave" />
      </ListItemAvatar>

      <ListItemText
        sx={{ pr: 2 }}
        primary={<Skeleton variant="text" width="80%" height={20} animation="wave" />}
        secondary={<Skeleton variant="text" width="60%" height={16} animation="wave" />}
      />
    </ListItem>
  );
};
